export class WidgetDescriptionConfig {
    constructor() {
        this.text = '';
        this.isDescriptionVisible = false;
        this.descriptionCss = '';
        this.descriptionContainerCss = '';
    }
}
//# sourceMappingURL=widget-description-config.model.js.map